/**
 * **********************************************************************************************
 * Extends the Tag component to display a status tag of type 'success', 'warning', or 'danger'. 🐺
 * ***********************************************************************************************
 *
 * @format
 */

import PropTypes from 'prop-types';
import {Tag} from '@sttark/design-system';
import React from 'react';

export const StatusTag = props => {
    const {type, label} = props;
    let color = 'black';
    let iconLeft = '';

    switch (type) {
        case 'success':
            color = '#009940';
            iconLeft = 'fa-check';
            break;
        case 'warning':
            color = '#E5B200';
            iconLeft = 'fa-warning';
            break;
        case 'danger':
            color = '#DF3D33';
            iconLeft = 'fa-close';
            break;
    }
    return (
        <div>
            <Tag color={color} iconLeft={iconLeft}>
                {label}
            </Tag>
        </div>
    );
};

// Prop types
StatusTag.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['success', 'warning', 'danger']).isRequired
};
